<template>
  <div class="content">
    <div class="label">
        {{ label }}
    </div>
    <div class="value">
        {{ value }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
  },
};

</script>

<style scoped>
  .content {
    display: grid;
    grid-template-columns: 60% 40%;
    font-weight: 500;
    font-size: 12px;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    margin-top: 8px;
  }

  .label {
    text-align: left;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .value {
    text-align: right;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
</style>
